import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Navbar from './components/navbar'
import About from './screens/about'
import Work from './screens/work'
import Portfolio from './screens/portfolio'

import './style/App.css'
import '../node_modules/bulma/css/bulma.css'



class App extends Component {

    render() {
        return (

            <Router>
                <section className='section' style={{overflow: 'scroll', paddingTop: 0}}>
                    <Navbar />
                    <Route exact path='/' component={About} />
                    <Route path='/work' component={Work} />
                    <Route path='/portfolio' component={Portfolio} />
                </section>
            </Router>

        )
    }

}

export default App



// WEBPACK FOOTER //
// ./src/App.js